export default {
      id: "ic-plan-parc-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-parc-usage",
      toString: function () {
        return this.url;
      }
    }